var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVscode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 41,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3647 39.7269C28.683 39.851 29.0234 39.9082 29.3648 39.8951C29.7062 39.882 30.0412 39.7988 30.3491 39.6507L38.5844 35.6879C39.0085 35.4837 39.3663 35.164 39.6168 34.7654C39.8672 34.3669 40 33.9057 40 33.435V6.56536C40.0001 6.09461 39.8673 5.63341 39.6168 5.23481C39.3664 4.83621 39.0085 4.51642 38.5844 4.31223L30.3491 0.350044C29.8837 0.12614 29.3603 0.0524202 28.8512 0.139088C28.3421 0.225755 27.8725 0.468524 27.5075 0.833794L11.7419 15.2169L4.87499 10.0041C4.56518 9.76903 4.18287 9.64977 3.79435 9.667C3.40582 9.68424 3.03558 9.83689 2.7478 10.0985L0.545303 12.1019C0.373661 12.258 0.236494 12.4482 0.142576 12.6604C0.048657 12.8726 5.48948e-05 13.102 -0.000121588 13.334C-0.000298071 13.566 0.0479549 13.7955 0.141551 14.0078C0.235146 14.2201 0.372024 14.4105 0.543427 14.5669L6.49874 20L0.54374 25.4335C0.37243 25.5899 0.235634 25.7803 0.142097 25.9926C0.0485591 26.2048 0.000337387 26.4343 0.000513852 26.6662C0.000690316 26.8982 0.049261 27.1276 0.143121 27.3397C0.236982 27.5518 0.374067 27.742 0.545615 27.8982L2.74811 29.9016C3.03586 30.1632 3.40608 30.316 3.7946 30.3332C4.18313 30.3505 4.56545 30.2313 4.8753 29.9963L11.7422 24.7838L27.5078 39.1666C27.7518 39.4105 28.0433 39.6013 28.3647 39.7269ZM30.0059 10.9197L18.0437 20L30.0062 29.0807L30.0059 10.9197Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5846 4.31871L30.3428 0.349963C29.8773 0.125771 29.3536 0.0518952 28.8442 0.138569C28.3349 0.225242 27.8651 0.468175 27.5 0.833712L0.519328 25.4334C0.34789 25.5897 0.210979 25.7801 0.117358 25.9924C0.0237377 26.2047 -0.024529 26.4342 -0.0243525 26.6662C-0.024176 26.8982 0.0244398 27.1276 0.118383 27.3397C0.212326 27.5518 0.349527 27.742 0.521203 27.8981L2.72495 29.9015C3.01278 30.1635 3.38325 30.3164 3.77205 30.3337C4.16086 30.351 4.54344 30.2316 4.85339 29.9962L37.3443 5.34777C38.4343 4.5209 40 5.2984 40 6.66652V6.5709C40 6.1003 39.8671 5.63924 39.6168 5.24077C39.3664 4.8423 39.0086 4.5229 38.5846 4.31871Z",
    fill: "#0065A9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_96_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5846 35.6815L30.3428 39.6496C29.8773 39.8739 29.3537 39.9479 28.8443 39.8613C28.335 39.7747 27.8652 39.5319 27.5 39.1665L0.519328 14.5665C0.34789 14.4102 0.210979 14.2198 0.117358 14.0075C0.0237377 13.7952 -0.024529 13.5657 -0.0243525 13.3337C-0.024176 13.1017 0.0244398 12.8723 0.118383 12.6602C0.212326 12.448 0.349527 12.2579 0.521203 12.1018L2.72495 10.0984C3.01278 9.83639 3.38325 9.68349 3.77205 9.6662C4.16086 9.6489 4.54344 9.7683 4.85339 10.0037L37.3443 34.6518C38.4343 35.479 40 34.7015 40 33.3334V33.429C40 33.8996 39.8671 34.3606 39.6168 34.7591C39.3664 35.1576 39.0086 35.4773 38.5846 35.6815Z",
    fill: "#007ACC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_96_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3431 39.6506C29.8775 39.8743 29.3538 39.9479 28.8445 39.8612C28.3352 39.7745 27.8654 39.5317 27.5 39.1665C28.4225 40.089 30 39.4356 30 38.1309V1.86869C30 0.563998 28.4225 -0.0894396 27.5 0.833373C27.8654 0.468119 28.3352 0.225363 28.8445 0.13865C29.3538 0.0519371 29.8775 0.125548 30.3431 0.34931L38.5834 4.31244C39.0078 4.51649 39.3658 4.83622 39.6165 5.23483C39.8671 5.63344 40 6.09472 40 6.56556V33.4349C40 33.9058 39.8671 34.3671 39.6165 34.7657C39.3658 35.1643 39.0078 35.484 38.5834 35.6881L30.3431 39.6506Z",
    fill: "#1F9CF0"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3406 39.7267C28.6589 39.8507 28.9992 39.9079 29.3406 39.8948C29.6819 39.8817 30.0169 39.7985 30.3247 39.6504L38.56 35.6876C38.9841 35.4834 39.342 35.1636 39.5925 34.765C39.8429 34.3664 39.9757 33.9052 39.9756 33.4345V6.56511C39.9757 6.09437 39.8429 5.63316 39.5925 5.23456C39.342 4.83597 38.9841 4.51617 38.56 4.31199L30.3247 0.3498C29.8593 0.125896 29.3359 0.052176 28.8268 0.138843C28.3177 0.225511 27.8482 0.468279 27.4831 0.83355L11.7175 15.2167L4.85061 10.0042C4.54079 9.76909 4.15849 9.64983 3.76996 9.66707C3.38144 9.68431 3.0112 9.83696 2.72342 10.0986L0.52092 12.102C0.349322 12.2581 0.212193 12.4484 0.118302 12.6605C0.024411 12.8727 -0.0241761 13.1021 -0.0243525 13.3341C-0.024529 13.5661 0.023709 13.7956 0.117277 14.0079C0.210845 14.2202 0.347684 14.4106 0.519045 14.567L6.47436 19.9998L0.519358 25.4329C0.347954 25.5893 0.211076 25.7797 0.117481 25.992C0.023885 26.2043 -0.024368 26.4338 -0.0241915 26.6658C-0.0240151 26.8979 0.024587 27.1273 0.118506 27.3394C0.212424 27.5516 0.349591 27.7418 0.521232 27.8979L2.72373 29.9014C3.01147 30.163 3.3817 30.3157 3.77022 30.333C4.15874 30.3503 4.54107 30.2311 4.85092 29.9961L11.7181 24.7832L27.4837 39.1664C27.7276 39.4102 28.0194 39.601 28.3406 39.7267ZM29.9819 10.9192L18.0194 19.9998L29.9819 29.0801V10.9192Z",
    fill: "url(#paint0_linear_96_313)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_96_313",
    x: -1.0661,
    y: 8.6228,
    width: 42.1078,
    height: 32.3154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.520875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_96_313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_96_313",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_96_313",
    x: 26.4583,
    y: -0.938478,
    width: 14.5835,
    height: 41.8767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.520875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_96_313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_96_313",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_313",
    x1: 19.9756,
    y1: 0.102925,
    x2: 19.9756,
    y2: 39.8967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.d9831743139a6ab5c3087316f574fb75.svg";
export { ForwardRef as ReactComponent };